module.exports = __webpack_public_path__ + "img/germany-ovarian-cancer-female.a7884bc0.png";